import { makeStyles } from "tss-react/mui";

const useMenutyles = makeStyles()((theme) => ({
  root: {
    "& .MuiPaper-root": {
      padding: "0 8px",
      backgroundColor: theme.palette.surface.bg,
    },

    "& .MuiMenuItem-root": {
      padding: "10px",
      backgroundColor: theme.palette.surface.light,
      borderBottom: `1px solid ${theme.palette.strokes.defaultGrey}`,
    },
  },
}));

export default useMenutyles;
